import { Link } from 'react-router-dom';

const LOGO_URL = 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b9e0099c33a19326b8165990727f4d26.png';

const serviceLinks = [
  { label: 'Aile Terapisi', href: '/aile-terapisi' },
  { label: 'Çift ve Evlilik Danışmanlığı', href: '/cift-evlilik-danismanligi' },
  { label: 'Bireysel Danışmanlık', href: '/bireysel-danismanlik' },
  { label: 'Çocuk & Ergen Danışmanlığı', href: '/cocuk-ergen-danismanligi' },
  { label: 'Cinsel Terapi', href: '/cinsel-terapi' },
  { label: 'Boşanma ve Yas Süreci', href: '/bosanma-yas-sureci' },
];

export default function Footer() {
  return (
    <footer className="bg-warm-dark text-warm-pale">
      {/* Ücretsiz İlk Seans Bandı */}
      <div className="border-b border-warm-pale/10 bg-warm-pale/5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left">
          <span className="text-xs text-gold font-medium tracking-wider uppercase">Ücretsiz İlk Seans</span>
          <span className="hidden sm:block w-px h-4 bg-warm-pale/20" />
          <span className="text-xs text-warm-pale/60">Online &amp; Yüz Yüze Seans İmkânı</span>
          <span className="hidden sm:block w-px h-4 bg-warm-pale/20" />
          <span className="text-xs text-warm-pale/60">Bireysel · Yas · Nişanlılık &amp; Evlilik Terapisi</span>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img src={LOGO_URL} alt="Ayşegül Sert Logo" className="h-12 w-auto object-contain mb-5 brightness-0 invert opacity-80" />
            <p className="text-sm leading-relaxed text-warm-pale/70 max-w-xs">
              Uzm. Aile Danışmanı Ayşegül Sert olarak; aileler, çiftler ve bireyler için güvenli, bilimsel ve empatik bir danışmanlık ortamı sunuyorum.
            </p>
            <div className="flex gap-3 mt-6">
              <a
                href="https://www.instagram.com/aysegulsertofficial/"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-warm-pale/20 hover:border-gold hover:text-gold transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base" />
              </a>
              <a
                href="https://wa.me/+905309042429"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-warm-pale/20 hover:border-gold hover:text-gold transition-colors cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-base" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-serif text-warm-pale font-semibold mb-5 text-base">
              <a href="/#hizmetler" className="hover:text-gold transition-colors">Hizmetler</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-warm-pale/60 hover:text-gold transition-colors flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-gold/40 group-hover:bg-gold transition-colors flex-shrink-0" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-warm-pale font-semibold mb-5 text-base">İletişim</h4>
            <ul className="flex flex-col gap-3.5">
              <li>
                <a
                  href="https://wa.me/+905309042429"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center gap-3 text-sm text-warm-pale/60 hover:text-gold transition-colors cursor-pointer"
                >
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-gold" />
                  </span>
                  +90 530 904 24 29
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/aysegulsertofficial/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="flex items-center gap-3 text-sm text-warm-pale/60 hover:text-gold transition-colors cursor-pointer"
                >
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-instagram-line text-gold" />
                  </span>
                  @aysegulsertofficial
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-warm-pale/60 mt-1">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-vidicon-line text-gold" />
                </span>
                <span>Online &amp; Yüz Yüze Seans</span>
              </li>
              <li className="flex items-start gap-3 text-sm text-warm-pale/60">
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-gift-line text-gold" />
                </span>
                <span>İlk seans <strong className="text-gold font-medium">ücretsiz</strong></span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-warm-pale/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-warm-pale/40">© 2026 Uzm. Aile Danışmanı Ayşegül Sert. Tüm hakları saklıdır.</p>
          <p className="text-xs text-warm-pale/40">KVKK Aydınlatma Metni | Gizlilik Politikası</p>
        </div>
      </div>
    </footer>
  );
}